import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "Footer",
  class: "app-footer"
}
const _hoisted_2 = { class: "copyright" }
const _hoisted_3 = { class: "policy" }
const _hoisted_4 = ["href", "aria-label"]
const _hoisted_5 = ["href", "aria-label"]

import Localizer from "@Scripts/Common/Localizer";


export default /*@__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {

const localizer = Localizer;
const routes = (window as any).App.routes;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(localizer).get("App.Common.CopyRight")), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("a", {
        href: _unref(routes).UrlPrivacyPolicy,
        target: "_blank",
        class: "button",
        "aria-label": 'Beghelli.it - ' + _unref(localizer).get('App.Terms.PrivacyPolicy')
      }, _toDisplayString(_unref(localizer).get("App.Terms.PrivacyPolicy")), 9, _hoisted_4),
      _createElementVNode("a", {
        href: _unref(routes).UrlCookiePolicy,
        target: "_blank",
        class: "button",
        "aria-label": 'Beghelli.it - ' + _unref(localizer).get('App.Terms.CookiePolicy')
      }, _toDisplayString(_unref(localizer).get("App.Terms.CookiePolicy")), 9, _hoisted_5)
    ])
  ]))
}
}

})